import { Injectable } from '@angular/core';
import { FILE_EXTENSION_TYPE, FILE_BLOB_TYPE } from 'src/app/app.constants';
import * as FileSaver from 'file-saver'

@Injectable({
  providedIn: 'root'
})

export class DownloadFileService {
  constructor() { }

  previewSolarForm(solarFormDownloadData, rowData) {
    switch (rowData.extension) {
        case FILE_EXTENSION_TYPE.PDF: {
          var file = new Blob([solarFormDownloadData], {
            type: FILE_BLOB_TYPE.PDF,
          });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL, "_blank");
          break;
        }
        case FILE_EXTENSION_TYPE.TXT: {
          var file = new Blob([solarFormDownloadData], {
            type: FILE_BLOB_TYPE.TXT,
          });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL, "_blank");
          break;
        }
        case FILE_EXTENSION_TYPE.PNG: {
          var file = new Blob([solarFormDownloadData], {
            type: FILE_BLOB_TYPE.PNG,
          });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL, "_blank");
          break;
        }
        case FILE_EXTENSION_TYPE.JPG: {
          var file = new Blob([solarFormDownloadData], {
            type: FILE_BLOB_TYPE.JPG,
          });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL, "_blank");
          break;
        }
        case FILE_EXTENSION_TYPE.BMP: {
          var file = new Blob([solarFormDownloadData], {
            type: FILE_BLOB_TYPE.BMP,
          });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL, "_blank");
          break;
        }
        case FILE_EXTENSION_TYPE.GIF: {
          var file = new Blob([solarFormDownloadData], {
            type: FILE_BLOB_TYPE.GIF,
          });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL, "_blank");
          break;
        }
        default: {
          this.downloadSolarForm(
            solarFormDownloadData,
            rowData,
            false
          ); 
          break;
        }
      }
  }
  downloadAccountForm(fileData, cwsFormName) {
    const data: Blob = new Blob([fileData], {
      type: FILE_BLOB_TYPE.PDF
    });
    FileSaver.saveAs(data, cwsFormName + FILE_EXTENSION_TYPE.PDF);
  }

  downloadSolarForm(fileData, rowData, isSolarForm: boolean) {

    const fileName:string = isSolarForm ? rowData.formNumber + '-' + rowData.formName : rowData.formName

    switch (rowData.extension) {
     
      case FILE_EXTENSION_TYPE.DOC: {
        
        const data: Blob = new Blob([fileData], {
          type: FILE_BLOB_TYPE.DOC
        });
        FileSaver.saveAs(data, fileName + FILE_EXTENSION_TYPE.DOC);
        break;
      }
      case FILE_EXTENSION_TYPE.DOT: {
        
        const data: Blob = new Blob([fileData], {
          type: FILE_BLOB_TYPE.DOT
        });
        FileSaver.saveAs(data, fileName + FILE_EXTENSION_TYPE.DOT);
        break;
      }
      case FILE_EXTENSION_TYPE.DOCX: {
        
        const data: Blob = new Blob([fileData], {
          type: FILE_BLOB_TYPE.DOCX
        });
        FileSaver.saveAs(data, fileName + FILE_EXTENSION_TYPE.DOCX);
        break;
      }
      case FILE_EXTENSION_TYPE.DOCM: {
        
        const data: Blob = new Blob([fileData], {
          type: FILE_BLOB_TYPE.DOCM
        });
        FileSaver.saveAs(data, fileName + FILE_EXTENSION_TYPE.DOCM);
        break;
      }
      case FILE_EXTENSION_TYPE.DOTX: {
        
        const data: Blob = new Blob([fileData], {
          type: FILE_BLOB_TYPE.DOTX
        });
        FileSaver.saveAs(data, fileName + FILE_EXTENSION_TYPE.DOTX);
        break;
      }
      case FILE_EXTENSION_TYPE.DOTM: {
        
        const data: Blob = new Blob([fileData], {
          type: FILE_BLOB_TYPE.DOTM
        });
        FileSaver.saveAs(data, fileName + FILE_EXTENSION_TYPE.DOTM);
        break;
      }
      case FILE_EXTENSION_TYPE.PDF: {
        const data: Blob = new Blob([fileData], {
          type: FILE_BLOB_TYPE.PDF
        });
        FileSaver.saveAs(data, fileName + FILE_EXTENSION_TYPE.PDF);
        break;
      }     
      case FILE_EXTENSION_TYPE.XLS: {
        const data: Blob = new Blob([fileData], {
          type: FILE_BLOB_TYPE.XLS
        });
        FileSaver.saveAs(data, fileName + FILE_EXTENSION_TYPE.XLS);
        break;
      }  
      case FILE_EXTENSION_TYPE.XLT: {
        const data: Blob = new Blob([fileData], {
          type: FILE_BLOB_TYPE.XLT
        });
        FileSaver.saveAs(data, fileName + FILE_EXTENSION_TYPE.XLT);
        break;
      } 
      case FILE_EXTENSION_TYPE.XLM: {
        const data: Blob = new Blob([fileData], {
          type: FILE_BLOB_TYPE.XLM
        });
        FileSaver.saveAs(data, fileName + FILE_EXTENSION_TYPE.XLM);
        break;
      }  
      case FILE_EXTENSION_TYPE.XLSX: {
        const data: Blob = new Blob([fileData], {
          type: FILE_BLOB_TYPE.XLSX
        });
        FileSaver.saveAs(data, fileName + FILE_EXTENSION_TYPE.XLSX);
        break;
      }     
      case FILE_EXTENSION_TYPE.XLSM: {
        const data: Blob = new Blob([fileData], {
          type: FILE_BLOB_TYPE.XLSM
        });
        FileSaver.saveAs(data, fileName + FILE_EXTENSION_TYPE.XLSM);
        break;
      }
      case FILE_EXTENSION_TYPE.XLTX: {
        const data: Blob = new Blob([fileData], {
          type: FILE_BLOB_TYPE.XLTX
        });
        FileSaver.saveAs(data, fileName + FILE_EXTENSION_TYPE.XLTX);
        break;
      }
      case FILE_EXTENSION_TYPE.XLTM: {
        const data: Blob = new Blob([fileData], {
          type: FILE_BLOB_TYPE.XLTM
        });
        FileSaver.saveAs(data, fileName + FILE_EXTENSION_TYPE.XLTM);
        break;
      }
      case FILE_EXTENSION_TYPE.CSV: {
        const data: Blob = new Blob([fileData], {
          type: FILE_BLOB_TYPE.CSV
        });
        FileSaver.saveAs(data, fileName + FILE_EXTENSION_TYPE.CSV);
        break;
      }
      case FILE_EXTENSION_TYPE.PPT: {
        const data: Blob = new Blob([fileData], {
          type: FILE_BLOB_TYPE.PPT
        });
        FileSaver.saveAs(data, fileName + FILE_EXTENSION_TYPE.PPT);
        break;
      }
      case FILE_EXTENSION_TYPE.POT: {
        const data: Blob = new Blob([fileData], {
          type: FILE_BLOB_TYPE.POT
        });
        FileSaver.saveAs(data, fileName + FILE_EXTENSION_TYPE.POT);
        break;
      }
      case FILE_EXTENSION_TYPE.PPS: {
        const data: Blob = new Blob([fileData], {
          type: FILE_BLOB_TYPE.PPS
        });
        FileSaver.saveAs(data, fileName + FILE_EXTENSION_TYPE.PPS);
        break;
      }
      case FILE_EXTENSION_TYPE.PPTX: {
        const data: Blob = new Blob([fileData], {
          type: FILE_BLOB_TYPE.PPTX
        });
        FileSaver.saveAs(data, fileName + FILE_EXTENSION_TYPE.PPTX);
        break;
      }
      case FILE_EXTENSION_TYPE.PPTM: {
        const data: Blob = new Blob([fileData], {
          type: FILE_BLOB_TYPE.PPTM
        });
        FileSaver.saveAs(data, fileName + FILE_EXTENSION_TYPE.PPTM);
        break;
      }
      case FILE_EXTENSION_TYPE.POTX: {
        const data: Blob = new Blob([fileData], {
          type: FILE_BLOB_TYPE.POTX
        });
        FileSaver.saveAs(data, fileName + FILE_EXTENSION_TYPE.POTX);
        break;
      }
      case FILE_EXTENSION_TYPE.POTM: {
        const data: Blob = new Blob([fileData], {
          type: FILE_BLOB_TYPE.POTM
        });
        FileSaver.saveAs(data, fileName + FILE_EXTENSION_TYPE.POTM);
        break;
      }
      case FILE_EXTENSION_TYPE.PPSX: {
        const data: Blob = new Blob([fileData], {
          type: FILE_BLOB_TYPE.PPSX
        });
        FileSaver.saveAs(data, fileName + FILE_EXTENSION_TYPE.PPSX);
        break;
      }
      case FILE_EXTENSION_TYPE.PPSM: {
        const data: Blob = new Blob([fileData], {
          type: FILE_BLOB_TYPE.PPSM
        });
        FileSaver.saveAs(data, fileName + FILE_EXTENSION_TYPE.PPSM);
        break;
      }
      case FILE_EXTENSION_TYPE.SLDX: {
        const data: Blob = new Blob([fileData], {
          type: FILE_BLOB_TYPE.SLDX
        });
        FileSaver.saveAs(data, fileName + FILE_EXTENSION_TYPE.SLDX);
        break;
      }
      case FILE_EXTENSION_TYPE.SLDM: {
        const data: Blob = new Blob([fileData], {
          type: FILE_BLOB_TYPE.SLDM
        });
        FileSaver.saveAs(data, fileName + FILE_EXTENSION_TYPE.SLDM);
        break;
      }
      case FILE_EXTENSION_TYPE.TXT: {
        const data: Blob = new Blob([fileData], {
          type: FILE_BLOB_TYPE.TXT
        });
        FileSaver.saveAs(data, fileName + FILE_EXTENSION_TYPE.TXT);
        break;
      }
      case FILE_EXTENSION_TYPE.BMP: {
        const data: Blob = new Blob([fileData], {
          type: FILE_BLOB_TYPE.BMP
        });
        FileSaver.saveAs(data, fileName + FILE_EXTENSION_TYPE.BMP);
        break;
      }
      case FILE_EXTENSION_TYPE.GIF: {
        const data: Blob = new Blob([fileData], {
          type: FILE_BLOB_TYPE.GIF
        });
        FileSaver.saveAs(data, fileName + FILE_EXTENSION_TYPE.GIF);
        break;
      }
      case FILE_EXTENSION_TYPE.TIF: {
        const data: Blob = new Blob([fileData], {
          type: FILE_BLOB_TYPE.TIF
        });
        FileSaver.saveAs(data, fileName + FILE_EXTENSION_TYPE.TIF);
        break;
      }
      case FILE_EXTENSION_TYPE.TIFF: {
        const data: Blob = new Blob([fileData], {
          type: FILE_BLOB_TYPE.TIFF
        });
        FileSaver.saveAs(data, fileName + FILE_EXTENSION_TYPE.TIFF);
        break;
      }
      case FILE_EXTENSION_TYPE.JPG: {
        const data: Blob = new Blob([fileData], {
          type: FILE_BLOB_TYPE.JPG
        });
        FileSaver.saveAs(data, fileName + FILE_EXTENSION_TYPE.JPG);
        break;
      }
      case FILE_EXTENSION_TYPE.JPEG: {
        const data: Blob = new Blob([fileData], {
          type: FILE_BLOB_TYPE.JPEG
        });
        FileSaver.saveAs(data, fileName + FILE_EXTENSION_TYPE.JPEG);
        break;
      }
      case FILE_EXTENSION_TYPE.PNG: {
        const data: Blob = new Blob([fileData], {
          type: FILE_BLOB_TYPE.PNG
        });
        FileSaver.saveAs(data, fileName + FILE_EXTENSION_TYPE.PNG);
        break;
      }
      case FILE_EXTENSION_TYPE.RTF: {
        const data: Blob = new Blob([fileData], {
          type: FILE_BLOB_TYPE.RTF
        });
        FileSaver.saveAs(data, fileName + FILE_EXTENSION_TYPE.RTF);
        break;
      }
      case FILE_EXTENSION_TYPE.ZIP: {
        const data: Blob = new Blob([fileData], {
          type: FILE_BLOB_TYPE.ZIP
        });
        FileSaver.saveAs(data, fileName + FILE_EXTENSION_TYPE.ZIP);
        break;
      }
      case FILE_EXTENSION_TYPE.STP: {
        const data: Blob = new Blob([fileData], {
          type: FILE_BLOB_TYPE.STP
        });
        FileSaver.saveAs(data, fileName + FILE_EXTENSION_TYPE.STP);
        break;
      }
      default: {
        //statements; 
        break;
      }
    }
}
}
